import React, { Component } from 'react'
import './flags.css'


class Flags extends Component {

	state = {
		france: true,
		england: false,
		rusia: false
	}



	render() {

		const clickFlag = (e) => {
			const clicked = e.target.getAttribute("data-lang")

			const { selectLang } = this.props;

			this.setState({
				france: false,
				england: false,
				rusia: false,
				[clicked]: true
			})

			selectLang(clicked)
		}



		return (
			<div className="flags-wrap" >
				<div className="flags">
					<div className="france" >
						<img src="img/flags/france.jpg" alt="france" data-lang="france"
							className={(this.state.france ? "active" : "")}
							onClick={clickFlag}
						/>
					</div>
					<div className="england">
						<img src="img/flags/england.jpg" alt="england" data-lang="england"
							className={(this.state.england ? "active" : "")}
							onClick={clickFlag}
						/>
					</div>
					<div className="rusia">
						<img src="img/flags/rusia.jpg" alt="rusia" data-lang="rusia"
							className={(this.state.rusia ? "active" : "")}
							onClick={clickFlag}
						/>
					</div>
				</div>
			</div>
		)
	}


}

export default Flags


// WEBPACK FOOTER //
// ./src/components/Flags/Flags.jsx